import user from './user';
import postcode from './postcode';
import customers from './customers';
import languages from './languages';
import events from './events';
import markets from './markets';
import sports from './sports';
import competitions from './competitions';
import transactions from './transactions';
import participants from './participants';
import tags from './tags';
import chats from './trader-chat';
import notifications from './notifications';
import betslip from './betslip';
import bets from './bets';
import payments from './payments';
import reports from './reports';
import selections from './selections';
import grades from './grades';
import marketTemplates from './market-templates';
import betTicker from './bet-ticker';
import roles from './roles';
import permissions from './permissions';
import staff from './staff';
import audits from './audits';
import countries from './countries';
import liabilities from './liabilities';
import systemSettings from './system-settings';
import bonuses from './bonuses';
import documents from './documents';
import ladders from './ladders';
import fraudAndCompliance from './fraud-and-compliance';
import banners from './banners';
import relatedContingency from './related-contingency';

// eslint-disable-next-line import/no-default-export
export default {
    user,
    postcode,
    customers,
    languages,
    events,
    markets,
    sports,
    competitions,
    transactions,
    participants,
    tags,
    chats,
    notifications,
    betslip,
    bets,
    reports,
    selections,
    grades,
    marketTemplates,
    betTicker,
    payments,
    roles,
    permissions,
    staff,
    audits,
    countries,
    liabilities,
    systemSettings,
    bonuses,
    documents,
    ladders,
    relatedContingency,
    fraudAndCompliance,
    banners,
};
